/**
 * Returns `true` if the given value (typically a nested `react-hook-form` error object)
 * contains at least one "FieldError-like" node somewhere in its tree.
 *
 * This is useful because `errors.somePath` may be an empty object (truthy) even when
 * there are no actual field errors under that path.
 */
export const getHasNestedErrors = (value: unknown): boolean => {
    if (!value) {
        return false;
    }

    if (typeof value !== "object") {
        return false;
    }

    const record = value as Record<string, unknown>;

    if (typeof record.message === "string" || typeof record.type === "string" || typeof record.ref === "object") {
        return true;
    }

    return Object.values(record).some((child) => getHasNestedErrors(child));
};
